import ManageArea from './manageArea'

export default ManageArea
